export const headerName = {
  add: "Добавить тип двигателя маломерного судна",
  edit: "Редактировать тип двигателя маломерного судна",
};
export const engineTypeInputs = {
  name: {
    key: "name",
    label: "Наименование типа двигателя маломерного судна",
    type: "text",
    required: true,
  },
};
export const getEngineTypeInputs = () => engineTypeInputs;
